import $ from "jquery";
import AjaxLoadedWebsiteModal from "modal/AjaxLoadedWebsiteModal";

$.extend(true, AjaxLoadedWebsiteModal.global_settings, {
    buildLoadingModal: () => (
        eotwJSXFactory('div', {className: "modal"}, [
            eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
            eotwJSXFactory('div', {className: "modal__container"}, [
                eotwJSXFactory('div', {className: "modal__box"}, [
                    eotwJSXFactory('div', {className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__content"}, [
                        eotwJSXFactory('div', {className: "loading"})
                    ])
                ])
            ])
        ])
    ),
    cycleIds: false
});
